import React from 'react';
import { Link } from 'react-router-dom';

export interface ISidebarProps {
  homeLink: string;
  /** Primary navigation (rendered inside `<nav className="sidebar-nav">`). */
  topItems: React.ReactNode;
  /** Notifications and the current user — always at the bottom, separated from the navigation. */
  bottomItems: React.ReactNode;
}

/** Fixed 256px white sidebar with a right border. Never changes width. */
export const Sidebar: React.FC<ISidebarProps> = (props) => {
  const { homeLink, topItems, bottomItems } = props;

  return (
    <div className="min-h-screen w-sidebar">
      <aside className="fixed left-0 top-0 z-dialog flex h-screen w-sidebar flex-col border-r border-border bg-surface">
        <div className="flex h-16 shrink-0 items-center px-5">
          <Link to={homeLink} className="inline-flex">
            <img className="h-8 w-auto" src="/static/logo-dark.svg" alt="TransDirect" />
          </Link>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto pb-4">{topItems}</div>

        <div className="shrink-0 border-t border-border py-2">{bottomItems}</div>
      </aside>
    </div>
  );
};
